<div class="flex flex-col gap-4">
  <app-dropdown
    [field]="chapterTree"
    [id]="chapterField().id"
    [label]="chapterField().label"
    [placeholder]="chapterField().placeholder"
    [options]="chapterField().options" />
  <app-dropdown
    [field]="itemTree"
    [id]="itemField().id"
    [label]="itemField().label"
    [placeholder]="itemField().placeholder"
    [options]="itemField().options" />

  <div class="rounded-lg bg-utility-gray-50 p-4 flex flex-col gap-2">
    @if (compositeValue(); as value) {
      @let breadcrumb = breadcrumbParts();
      <p class="text-sm text-secondary m-0" data-testid="shipsan-breadcrumb">
        {{ breadcrumb.path
        }}<span class="font-semibold"
          >{{ breadcrumb.last }} {{ value.title }}</span
        >
      </p>
      <div class="flex items-center gap-2 flex-wrap">
        <span
          class="chip chip-xs"
          [class]="pointsChipClass(value.pointValue)"
          data-testid="shipsan-points-badge"
          >{{ pointsText(value.pointValue) }}</span
        >
        <span class="chip chip-xs chip-checklist-badge"
          >{{ value.typeLabel }} ({{ value.type }})</span
        >
        <span class="chip chip-xs chip-checklist-badge"
          >Manual p. {{ value.page }}</span
        >
      </div>
      <app-expandable-text [text]="value.description" />
    } @else {
      <p class="m-0 text-secondary">{{ placeholderText }}</p>
    }
  </div>
</div>
